import {
    state
} from 'redux';

const DefaultEventTypeColour = "#2075FE";

function timelineReducer(state = {loading:true, filterByTagIds: [-1, 1041],defaultTagIds: [-1, 1041]}, action) {

    switch (action.type) {
        case 'SHOW_STORY':

        return { ...state,
            selectedEventTypeIds: [parseInt(action.eventTypeId)],
            sortByEventTypeId: action.eventTypeId,
            filterByTagIds: action.filterByTagIds
        };

        case 'FILTER_BY_EVENT_TYPE':
            return { ...state,
                selectedEventTypeIds: [parseInt(action.eventTypeId)],
                sortByEventTypeId: action.eventTypeId
            };


        case 'FILTER_BY_EVENT_TYPES':
            return { ...state,
                selectedEventTypeIds: action.selectedEventTypeIds
            };

            case 'FILTER_BY_TAGS':
            return { ...state,
                filterByTagIds: action.filterByTagIds
            };

        case 'LOADING':
        return {
                ...state,
                loading: true
            };
        case 'FINISHED_LOADING':
            return {
                ...state,
                loading: false,
                eventTypes: action.eventTypes,
                tags: action.tags,
                events: action.events,
                selectedEventTypeIds: action.selectedEventTypeIds
            };
    }
    return state;

}

function showStory(eventTypeId, filterByTagIds) {
    return dispatch => {
        dispatch({
            type: 'SHOW_STORY',
            eventTypeId: eventTypeId,
            filterByTagIds: filterByTagIds
        });
    }

}

function filterByTagIds(filterByTagIds) {
    return dispatch => {
        dispatch({type:'FILTER_BY_TAGS',filterByTagIds: filterByTagIds});

    }
}

function sortByEventTypeId(eventTypeId) {
    return dispatch => {
        dispatch({
            type: 'FILTER_BY_EVENT_TYPE',
            eventTypeId: eventTypeId
        });
    }

}

function selectEventTypeIds(ids) {
    return dispatch => {
        dispatch({
            type: 'FILTER_BY_EVENT_TYPES',
            selectedEventTypeIds: ids
        });
    };
}

function loadDataAction() {

    return dispatch => {

        fetch("http://www.almotanabbi.com/ws1.0/getTlimelineEventsList.do").then(
            response => {
                response.json().then(events => {
                        events.forEach(theEvent => {
                            theEvent.fromYear = convertYear(
                                theEvent.fromYear,
                                theEvent.dateType
                            );
                            theEvent.toYear = convertYear(
                                theEvent.toYear,
                                theEvent.dateType
                            );
                            if (theEvent.toYear === undefined) {
                                theEvent.duration = 1;
                            } else {
                                theEvent.duration = Math.abs(
                                    theEvent.toYear - theEvent.fromYear
                                );
                            }
                        });

                        const uniqueTags = getUniqueTags(events);
                        const eventTypes = getUniqueEventTypes(events);

                        const selectedEventTypeIds = [
                            ...eventTypes.map(eventType => eventType.eventTypeId)
                        ];

                        dispatch({
                            type: 'FINISHED_LOADING',
                            events: events,
                            eventTypes: eventTypes,
                            tags: uniqueTags,
                            selectedEventTypeIds: selectedEventTypeIds
                        });


                    }


                )
            }

        )

        dispatch({
            type: 'LOADING',
        });

    }


}

function getEventTypesByTypeIdAndStatictis(events) {
    var eventTypesStatistics = [];
    events.forEach(theEvent => {
        var eventTypeId = null;
        if (theEvent.timelineEventType === undefined) {
            eventTypeId = 0;
        } else {
            eventTypeId = theEvent.timelineEventType.eventTypeId;
        }
        var count =
            eventTypesStatistics[eventTypeId] === undefined ?
            1 :
            eventTypesStatistics[eventTypeId] + 1;
        eventTypesStatistics[eventTypeId] = count;
    });
    return eventTypesStatistics;
}



function getUniqueEventTypes(events) {

    var typesStatistics = getEventTypesByTypeIdAndStatictis(events);
    var uniqueTypes = [];
    uniqueTypes.push({
        eventTypeId: -1,
        colour: DefaultEventTypeColour,
        typeName: `غير محدد`,
        count: typesStatistics[0]
    });
    events.forEach(theEvent => {
        if (theEvent.timelineEventType != null) {
            var eventTypeId = theEvent.timelineEventType.eventTypeId;
            uniqueTypes[eventTypeId] = {
                eventTypeId: eventTypeId,
                colour: "#" + theEvent.timelineEventType.colour,
                typeName: theEvent.timelineEventType.typeName,
                count: typesStatistics[eventTypeId]
            };
        }
    });
    return uniqueTypes;
}


function getTagsByTagIdAndStatictis(events) {
    var tagsStatistics = [];
    events.forEach(theEvent => {
        const tagId = theEvent.tag !== undefined ? theEvent.tag.tagId : -1;
        const count =
            tagsStatistics[tagId] === undefined ? 1 : tagsStatistics[tagId] + 1;
        tagsStatistics[tagId] = count;
    });
    return tagsStatistics;
}



function getUniqueTags(events) {
    var tagsStatistics = getTagsByTagIdAndStatictis(events);
    var tagIds = [];
    var uniqueTags = [];


    events.forEach(theEvent => {
        if (
            theEvent.tag !== undefined &&
            tagIds[theEvent.tag.tagId] === undefined
        ) {
            var tagId = theEvent.tag.tagId;
            tagIds[tagId] = true;
            uniqueTags.push({
                tagId: tagId,
                name: theEvent.tag.name,
                description: theEvent.tag.description,
                totalEvents: tagsStatistics[tagId],
                relatedTags: theEvent.relatedTags
            });
        }
    });
    // Sort by almotanabbi first.
    uniqueTags.sort((a, b) => (a.tagId === 1041 ? -1 : 1));

    const noTag = {
        tagId: -1,
        name: 'أحداث عامة',
        description: '',
        totalEvents: tagsStatistics[-1]
    };

    uniqueTags = [noTag, ...uniqueTags];
    return uniqueTags;
}



function convertYear(year, dateType) {
    if (dateType == "m") {
        const hijriYear = Math.ceil((year - 623) * 1.0334);
        return hijriYear;
    }
    return year;
}

export {
    timelineReducer,
    loadDataAction,
    selectEventTypeIds,
    sortByEventTypeId,
    showStory,
    filterByTagIds
};




// WEBPACK FOOTER //
// ./src/TimelineReducer.js